import { useCallback, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, Flex, Grid, Image, Paper, Text } from "@mantine/core";
import { Review } from "src/graphql/generated/graphql";
import { CampaignQueryDataType } from "src/hooks/campaigns";

import { ExportCampaignResultsModal } from "../../../../modals/ExportCampaignResults";
import { LightBox } from "../../../LightBox";

export interface ImagesTabProps {
    campaign: CampaignQueryDataType;
    reviews: Review[];
}

export const ImagesTab = ({ campaign, reviews }: ImagesTabProps) => {
    const { t } = useTranslation(["common"]);

    const [selectedImageIndex, setSelectedImageIndex] = useState<number>(-1);

    const allImages = useMemo(() => {
        return [
            ...(campaign?.images || []).map((file) => file.file),
            ...(reviews || []).flatMap((review) => review?.images),
        ];
    }, [campaign?.images, reviews]);

    const handleClose = useCallback(() => {
        setSelectedImageIndex(-1);
    }, []);


    return (
        <Paper p={36} radius={12}>
            <Flex mb={24} align="center" justify="space-between" wrap="wrap" gap={10}>
                <Text style={{ whiteSpace: "nowrap" }} weight={600}>
                    {allImages?.length} {t("campaign_images_photos_from_campaign")}
                </Text>
                <Button radius={8} variant="default" onClick={() =>
                    ExportCampaignResultsModal.display({
                        campaignId: campaign.id,
                    })
                }>
                    {t("campaign_images_export_all_photos")}
                </Button>
            </Flex>
            <Grid>
                {(allImages || []).map((image, index) => (
                    <Grid.Col key={`${index}${image?.src}`} md={6} lg={4} xl={3}>
                        <Image
                            key={index}
                            radius={8}
                            height={184}
                            alt="Random image"
                            style={{ cursor: "pointer" }}
                            src={image?.src + "?w=400"}
                            onClick={() => setSelectedImageIndex(index)}
                        />
                    </Grid.Col>
                ))}
                {selectedImageIndex >= 0 && (
                    <LightBox
                        images={allImages}
                        selectedIndex={selectedImageIndex}
                        onClose={handleClose}
                    />
                )}
            </Grid>
        </Paper>
    );
};
